var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47,
    r: 47,
    fill: "#DC3545",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_30736)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3661 23.9176C39.3662 23.5581 39.509 23.2132 39.7632 22.9589C40.0174 22.7046 40.3622 22.5616 40.7218 22.5613L54.2775 22.5605C54.6372 22.5614 54.9818 22.7048 55.236 22.9593C55.4901 23.2138 55.6329 23.5587 55.6332 23.9184V27.271H39.3661V23.9176ZM61.6544 69.4985C61.6198 70.0272 61.3845 70.5226 60.9966 70.8834C60.6087 71.2442 60.0976 71.4431 59.5678 71.4394H35.2757C34.7461 71.438 34.2366 71.2362 33.8496 70.8747C33.4626 70.5132 33.2267 70.0186 33.1893 69.4903L31.1106 39.0818H63.873L61.6549 69.4981L61.6544 69.4985ZM67.0549 36.3277H27.9453V33.1772C27.9459 32.3417 28.278 31.5405 28.8688 30.9496C29.4596 30.3587 30.2607 30.0264 31.0963 30.0256L63.9035 30.0246C64.739 30.0259 65.5399 30.3585 66.1305 30.9494C66.7211 31.5404 67.0532 32.3415 67.054 33.177V36.3274L67.0549 36.3277ZM41.2029 64.1904C41.2029 64.3712 41.2385 64.5502 41.3077 64.7173C41.3769 64.8843 41.4783 65.0361 41.6061 65.1639C41.734 65.2918 41.8858 65.3932 42.0528 65.4624C42.2199 65.5316 42.3989 65.5672 42.5797 65.5672C42.7605 65.5672 42.9396 65.5316 43.1066 65.4624C43.2737 65.3932 43.4254 65.2918 43.5533 65.1639C43.6811 65.0361 43.7826 64.8843 43.8518 64.7173C43.921 64.5502 43.9566 64.3712 43.9566 64.1904V44.8821C43.9537 44.519 43.8074 44.1717 43.5497 43.9159C43.2919 43.6601 42.9436 43.5165 42.5804 43.5164C42.2173 43.5163 41.8688 43.6596 41.6109 43.9153C41.353 44.1709 41.2065 44.518 41.2033 44.8811V64.1904H41.2029ZM51.0266 64.1904C51.0266 64.5556 51.1717 64.9058 51.4299 65.1641C51.6882 65.4223 52.0384 65.5674 52.4036 65.5674C52.7689 65.5674 53.1191 65.4223 53.3774 65.1641C53.6356 64.9058 53.7807 64.5556 53.7807 64.1904V44.8821C53.7778 44.5189 53.6315 44.1716 53.3737 43.9158C53.116 43.66 52.7675 43.5163 52.4044 43.5162C52.0412 43.5161 51.6927 43.6595 51.4347 43.9151C51.1767 44.1708 51.0302 44.518 51.0271 44.8811L51.0266 64.1904Z",
    fill: "#DC3545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_30736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.88,
    height: 48.88,
    fill: "white",
    transform: "translate(23.0601 22.56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b7068be5cb2f457af98dc9099ea0e29d.svg";
export { ForwardRef as ReactComponent };